import { BENEFITS_KEY_OVERRIDES } from 'helpers/benefits-key-overrides'
import { convertKeysToPascalCase } from 'helpers/convertKeysToPascalCase'

/**
 * EPS returns camelCase ClientBenefits; enrollme UI still reads PascalCase.
 * Uses the shared convertKeysToPascalCase helper (same as benefits-get remap).
 */
export function remapClientBenefitsGetResponse(raw) {
  const items = raw?.clientBenefits ?? raw?.ClientBenefits ?? []
  const remappedRoot = convertKeysToPascalCase(raw ?? {}, BENEFITS_KEY_OVERRIDES)

  return {
    ...remappedRoot,
    ClientBenefits: items.map((item) =>
      convertKeysToPascalCase(item, BENEFITS_KEY_OVERRIDES)
    ),
  }
}
